import { put } from 'redux-saga/effects';
import {
  searchSingleUserFromConsoleSuccess,
  searchSingleUserFromConsoleFail
} from '../../../../actions/userAdminDashboard';
import searchUsersForAdmin from '../../../apiCalls/searchUsersForAdmin';

function* searchSingleUserForConsole({ data }) {
  let apiResults = {};

  apiResults = yield searchUsersForAdmin(`?userId=${data.userId}`);

  if (apiResults.error || apiResults.status !== 'success') {
    yield put(searchSingleUserFromConsoleFail({ error: apiResults.message }));
  } else {
    yield put(searchSingleUserFromConsoleSuccess({ users: apiResults.data.users }));
  }
}

export default searchSingleUserForConsole;
